import React, { createContext, useContext } from "react";
import { Col, notification, Row, Spin } from "antd";
import ProgressNotification from "../components/Spin/ProgressNotification";
import Text from "../components/Text/Text";
const NotificationContext = createContext<any>(null);

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [api, contextHolder] = notification.useNotification();

  const startUploadProcess = (
    fileSize: string,
    progressValue: number,
    setProgressValue: React.Dispatch<React.SetStateAction<number>>,
    notificationProps?: {
      message: string;
      description: string;
      placement: "topRight" | "bottomRight" | "topLeft" | "bottomLeft";
      duration: number;
      label: string;
      progressInterval?: number;
    },
    onComplete?: () => void,
    setModalState?: React.Dispatch<
      React.SetStateAction<{
        isModalVisible: boolean;
        visible: boolean;
        modalError: boolean;
        modalOffline: boolean;
      }>
    >,
    path?: string,
  ) => {
    let progress = 0;
    setProgressValue(progress);
    const updateNotification = () => {
      api.open({
        message: (
          <ProgressNotification
            progress={progress}
            fileSize={fileSize}
            label={notificationProps?.label || "กำลังอัปโหลดไฟล์ของคุณ รออีกนิด!"}
          />
        ),
        placement: "bottomRight",
        duration: null,
        key: "uploadNotification",
      });
    };

    updateNotification();

    const interval = setInterval(() => {
      progress += 10;
      setProgressValue(progress);
      updateNotification();

      if (progress >= 100) {
        clearInterval(interval);
        api.destroy("uploadNotification");

        if (onComplete) {
          onComplete();
        } else {
          if (location.pathname.split("/")[3] === path) {
            if (setModalState) {
              setModalState((prevState) => ({ ...prevState, isModalVisible: true }));
              setTimeout(() => {
                setModalState((prevState) => ({ ...prevState, isModalVisible: false }));
                window.location.reload();
              }, 800);
            }
          } else {
            api.success({
              message: (
                <Row style={{ display: "flex", alignItems: "center", width: "100%" }}>
                  <Col span={20}>
                    <Text fontSize={16} fontWeight={700} fontFamily='Sarabun'>
                      {notificationProps?.message || "อัปโหลดไฟล์สำเร็จ"}
                    </Text>
                    <br />
                    <Text fontSize={14} fontWeight={400} color='grayishBlue'>
                      ไฟล์ขนาด {fileSize}
                    </Text>
                  </Col>
                </Row>
              ),
              placement: notificationProps?.placement || "bottomRight",
              duration: notificationProps?.duration || 2,
            });
          }
        }
      }
    }, notificationProps?.progressInterval || 500);
  };

  return (
    <NotificationContext.Provider value={{ api, startUploadProcess }}>
      {contextHolder}
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotificationContext = () => useContext(NotificationContext);
